import React, { useEffect, useState } from "react";
import Sidebar from "./sidebar";
import Topbar from "./topbar";
import { Outlet, useLocation, Navigate, useNavigate } from "react-router-dom";
import Authorization from "../../Main/authorization";
import toast from "react-hot-toast";
import { get_user_auth } from "../../Controllers/Layouts/Layouts";
import ExpiryNotification from "./ExpiryNotification";

const Layout = () => {
  let location = useLocation();

  const navigate = useNavigate();


  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        navigate(-1);
      }
    };

    window.addEventListener('keydown', handleEscape);

    return () => {
      window.removeEventListener('keydown', handleEscape);
    };
  }, [navigate]);

  let isAuthenticate = Authorization();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [showNotification, setShowNotification] = useState(true);

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const layouts = await get_user_auth();

      if (layouts?.status) {
        setBody(layouts?.data);
        setLoader(false);
      } else {
        toast?.error(layouts?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    if (isAuthenticate) {
      fetchData();
    }
  }, []);

  const getExpiryDate = () => {
    if (!body?.remaining_days) return null;
    const today = new Date();
    const expiryDate = new Date(today);
    expiryDate.setDate(today.getDate() + body.remaining_days);
    return expiryDate;
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar body={body} />
      <div className="flex flex-col flex-1 overflow-hidden ml-64">
        <Topbar body={body} />

        <div className="flex-1">

          {body?.is_less_than_31_days && body?.remaining_days && body.remaining_days > 0 && showNotification ? (
            <ExpiryNotification
              remainingDays={body.remaining_days}
              expiryDate={getExpiryDate()}
              onClose={handleCloseNotification}
            />
          ) : (<h2 className="text-lg font-semibold mb-9">Main Content</h2>)}

          <div className=""
            style={{ marginTop: body?.is_less_than_31_days && body?.remaining_days > 0 && showNotification ? "8.5rem" : "0" }}>
            {isAuthenticate && location?.pathname != "/app" ? (
              <Outlet />
            ) : isAuthenticate && location?.pathname == "/app" ? (
              <Navigate to={"/signin"} />
            ) : isAuthenticate && location?.pathname == "/app/" ? (
              <Navigate to={"/signin"} />
            ) : (
              <Navigate to={"/signin"} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
